import React from 'react';

import Main from 'layouts/Main';
import Container from 'components/Container';
import { Detail as MainSection } from './components';

const Video = () => {
    return (
        <Main>
            <Container>
                <MainSection />
            </Container>
        </Main>
    );
};

export default Video;
